<script>
export default {  
  computed: {
    isFormIncomplete() {
      return Object.values(this.fields).some((a) => !a);
    }
  },

  data() {
    return {
      errorMessage: null,
      fields: { email: '' },
      locked: true,
      waiting: false,
    };
  },
  
  methods: {
    async getToken() {
      grecaptcha.ready(() => {
        grecaptcha
          .execute('6LdqsAMqAAAAAKQUTtDJN9Xhqp5PUufWHAAklKBu', {
            action: 'videoGate',
          })
          .catch((error) => {
            console.error('Error executing reCAPTCHA:', error);
          })
          .then((res) => {
            this.submitForm(res);
          });
      });
    },

    async submitForm(token) {
      this.waiting = true;

      /**
       * Send request to server API.
       */
      const response = await fetch('/wp-json/bpp/v1/video-gate', {
        body: JSON.stringify({
          formData: this.fields,
          token,
        }),
        method: 'POST',
      });

      /**
       * Unlock video or display error message.
       */
      if (response) {
        this.waiting = false;

        const { message } = await response.json();

        if (response.ok) {
          this.locked = false;
          localStorage.setItem('bpp-video-gate', this.locked);
          this.triggerEvent();
        } else {
          this.errorMessage = message;
        }
      }
    },

    async triggerEvent() {
      window.gtag('event', 'page_view_unlocked');
    }
  },
  
  mounted() {
    const storageLocked = localStorage.getItem('bpp-video-gate');

    if (storageLocked !== null) {
      this.locked = JSON.parse(storageLocked);

      if (!this.locked) {
        this.triggerEvent();
      }
    }
  },

  name: 'video-gate',
};
</script>